export interface ErrorInfo {
  message: string;
  status?: number;
}

export function formatTimestamp(isoString: string): string {
  try {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) {
      return isoString;
    }
    return date.toLocaleString();
  } catch {
    return isoString;
  }
}

export function getDirectionIcon(direction: string): string {
  const lower = direction.toLowerCase();
  if (lower === 'positive' || lower === 'up') return '↑';
  if (lower === 'negative' || lower === 'down') return '↓';
  return '→';
}

export function getErrorMessage(error: unknown): ErrorInfo {
  if (error && typeof error === 'object' && 'response' in error) {
    const axiosError = error as { response?: { status?: number } };
    const status = axiosError.response?.status;
    if (status === 504) {
      return { message: 'Explanation timed out. Please retry.', status };
    }
    if (status === 502) {
      return { message: 'Explanation is unavailable. Please retry.', status };
    }
    return { message: 'Something went wrong. Please retry.', status };
  }
  if (error instanceof DOMException && error.name === 'AbortError') {
    return { message: 'Explanation timed out. Please retry.', status: 504 };
  }
  return { message: 'Something went wrong. Please retry.' };
}
